import { style } from '@do/walrus';
import Link from 'next/link';
import * as React from 'react';
import styled from 'styled-components';
import copy from '../copy';

const BreadcrumbContainer = styled.ol`
  padding-left: 0;
  margin-top: ${style.vars.space['3']};
  display: inline-block;
  list-style: none;

  > li:last-child:after {
    display: none;
  }
`;

const Breadcrumb = styled.li`
  display: inline-block;
  padding-left: 0;

  &:after {
    content: '>';
    font-size: ${style.vars.fontSize.small};
    color: ${style.colors.blue.dark};
    display: inline-block;
    margin: 0 8px;
  }

  a {
    color: ${style.colors.blue.dark};
    font-size: ${style.vars.fontSize.small};
  }
`;

interface Props {
  hrefs: string[];
  as: string[];
  text: string[];
  openInNewTab?: boolean;
}

const Breadcrumbs: React.FC<Props> = (props) => (
  <nav aria-label={copy.breadcrumbsLabel}>
    <BreadcrumbContainer>
      {props.as.map((asItem, index) => (
        <Breadcrumb key={asItem}>
          <Link
            href={props.hrefs[index]}
            as={asItem}
            prefetch={false}
            target={props.openInNewTab ? '_blank' : undefined}
          >
            {props.text[index]}
          </Link>
        </Breadcrumb>
      ))}
    </BreadcrumbContainer>
  </nav>
);

export default Breadcrumbs;
